import { setStorage, getStorage } from '../../utils/storage';
import { isBoolean, get, toNumber } from 'lodash';
// 保存语言
export function setLocalStorageLang(locale) {
    setStorage('BACK_OFFICE_LOCALE', locale);
}
// 获取语言
export function getLocalStorageLang() {
    const navigatorLanguage = get(window, 'navigator.language') === 'zh-CN' ? 'cn' : 'en';
    const locale = getStorage('BACK_OFFICE_LOCALE');
    return locale || navigatorLanguage;
}
export function setLocalStorageRememberMe(rememberMe) {
    setStorage('BACK_OFFICE_REMEMBER_ME', rememberMe);
}
export function getLocalStorageRememberMe() {
    const rememberMe = getStorage('BACK_OFFICE_REMEMBER_ME');
    return !!rememberMe;
}
// patsnap lab 包含内部用户开关
export function setLocalStorageIncludeInternal(includeInternal) {
    setStorage('BACK_OFFICE_INCLUDE_INTERNAL', includeInternal);
}
export function getLocalStorageIncludeInternal() {
    const includeInternal = getStorage('BACK_OFFICE_INCLUDE_INTERNAL');
    return !isBoolean(includeInternal) ? true : !!includeInternal;
}
// 套餐列表设置active菜单
export function setLocalStorageCurrentTab(index) {
    setStorage('BACK_OFFICE_PACKAGE_CURRENT_TAB', index);
}
export function getLocalStorageCurrentTab() {
    console.log(getStorage('BACK_OFFICE_PACKAGE_CURRENT_TAB'));
    return toNumber(getStorage('BACK_OFFICE_PACKAGE_CURRENT_TAB'));
}
export function setLocalStorageRouterNavMapData(data) {
    setStorage('BACK_OFFICE_ROUTER_NAV_MAP_DATA', data);
}
export function getLocalStorageRouterNavMapData() {
    const data = getStorage('BACK_OFFICE_ROUTER_NAV_MAP_DATA');
    return data || {};
}
export function clearLocalStorageRouterNavMapData() {
    localStorage.removeItem('BACK_OFFICE_ROUTER_NAV_MAP_DATA');
}
export function setLocalStorageReportFrequency(data) {
    setStorage('BACK_OFFICE_REPORT_FREQUENCY', data);
}
export function getLocalStorageReportFrequency() {
    const data = getStorage('BACK_OFFICE_REPORT_FREQUENCY');
    return data;
}
